/* eslint-env node */
/* eslint-disable import/no-commonjs */
/**
 * mSTEM — Mock "🤖 AI" result data (canonical, git-tracked source).
 *
 * Phase 7 / Plan 07-01: the SINGLE mock-truth source consumed by BOTH the mbfAI
 * extension opcodes (07-02) AND the AI panel control buttons (07-03). Keeping one
 * source means the standalone panel demo and the block report bubbles always agree
 * (RESEARCH Open Q2 — single source of mock truth).
 *
 * MOCK-ONLY (DR-00): no real inference, no cloud, no model. These are fixed sample
 * values surfaced after a simulated `setTimeout` delay (MOCK_DELAY_MS in the
 * extension). The "extract from URL" opcodes NEVER fetch the URL (SSRF guard,
 * RESEARCH Security V5) — they resolve these mock values regardless of input.
 *
 * CommonJS (module.exports) so the VM-side extension (which is require()'d from the
 * vendored node_modules copy) and unit tests resolve the same file.
 */

module.exports = {
    // Face recognition mock — list of detected faces with coordinates + confidence.
    faces: [
        {x: 120, y: 80, confidence: 0.92, name: 'Học sinh A'},
        {x: 340, y: 96, confidence: 0.87, name: 'Học sinh B'}
    ],
    // Body recognition mock — keypoint coordinates per body part.
    bodyParts: {
        eye: {x: 150, y: 110},
        nose: {x: 160, y: 140},
        mouth: {x: 158, y: 170},
        hand: {x: 90, y: 260}
    },
    // Hand analysis mock. `gestureKey` is the machine value the mbfAI GESTURE menu
    // uses ('open' | 'fist' | 'point') so the "does hand match [GESTURE]?" block can
    // answer from this data instead of hard-coding `true`; `gesture` stays the
    // human-readable VN label used by the AI panel.
    handData: {fingers: 5, gesture: 'mở bàn tay', gestureKey: 'open'},
    // Image recognition mock — label lists per identification kind.
    imageLabels: {
        label: ['chai nước', 'bàn'],
        celeb: ['(không có người nổi tiếng)'],
        brand: ['logo Mobifone']
    },
    // Generic object count (shared by body + image counters).
    objectCount: 3,
    // OCR EN mock — sample recognized text.
    ocrText: 'Hello mSTEM'
};
